import request from "api/request";

const publicRequest = ({ route, data = {}, useAPI = true }) => request({ route, data, useAPI });

export default publicRequest;
